export const TEAMS_EN = {
    
}